// components/subscription/PlansList.jsx
import React from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import PlanCard from './PlanCard';

const PlansList = ({ onSelectPlan }) => {
  const { availablePlans, loading, error } = useSubscription();

  if (loading) return <div className="text-center py-8">Loading plans...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!availablePlans || availablePlans.length === 0) return <div className="text-center py-8">No plans available</div>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {availablePlans.map(plan => (
        <PlanCard 
          key={plan.id} 
          plan={plan} 
          onSelect={() => onSelectPlan(plan.id)} 
        />
      ))}
    </div>
  );
};

export default PlansList;